import { BROCHURE_URL } from "./company";

// Opens the dossier in a new tab AND triggers a download.
// Works consistently across Chrome, Firefox, Safari and mobile browsers.
export function openAndDownloadDossier(e) {
  if (e && e.preventDefault) e.preventDefault();

  // 1. Force the download
  const a = document.createElement("a");
  a.href = BROCHURE_URL;
  a.download = "Aad-Labs-Export-Dossier.pdf";
  document.body.appendChild(a);
  a.click();
  a.remove();

  // 2. Also open the file in a new browser tab for instant preview
  window.open(BROCHURE_URL, "_blank", "noopener,noreferrer");
}
